import { render, staticRenderFns } from "./RemoveRealDataDialog.vue?vue&type=template&id=1b137b07&lang=pug&"
import script from "./RemoveRealDataDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveRealDataDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports